export default {
    "title": "Consulte seus pontos e recompensas com o seu telefone.",
    "phoneLabel": "Digite seu celular",
    "phonePlaceholder": "(99) 9 9999-9999",
    "enterButton": "Entrar",
    "step2Message1": "Estamos enviando um código para o seu celular via SMS, pode levar até 3 minutos para chegar.",
    "step2Message2": "Enviamos outro SMS para você, caso não receba por favor reporte o incidente ao nosso estabelecimento.",
    "authCode": "Código de Autenticação",
    "resendButton": "Enviar novamente",
    "resendWait": "Enviar novamente em {seconds}s",
    "codeLabel": "Código de confirmação",
    "codePlaceholder": "Digite o código aqui",
    "verifyButton": "Verificar",
    "backButton": "Voltar",
    "signupTitle": "Não encontramos seu celular no cadastro, por favor preencha o formulário para se cadastrar.",
    "firstNameLabel": "Nome",
    "firstNamePlaceholder": "Digite seu nome",
    "lastNameLabel": "Sobrenome",
    "lastNamePlaceholder": "Digite seu sobrenome",
    "birthdateLabel": "Data de nascimento",
    "birthdatePlaceholder": "00/00/0000",
    "emailLabel": "Seu e-mail",
    "emailPlaceholder": "email@email.com",
    "signUpButton": "Cadastrar",
    "errorUnknown": "Ocorreu um erro desconhecido, por favor tente mais tarde.",
    "errorPhoneNotFound": "Parece que você nunca fez um pedido aqui, estamos lhe esperando!",
    "errorInvalidCode": "O código informado é inválido, tente novamente."
};
